import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet, callTheApServerPost } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { byId } from './helpers/utility';





authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert






const headerColorInput = byId('headerColorInput');
const headerBackgroundColorInput = byId('headerBackgroundColorInput');

const bottomNavbarBackgroundColorInput = byId('bottomNavbarBackgroundColorInput');

const getCustomUiData = async () => {

    try {
        const response = await callTheApServerGet(`/customUi/getCustomUiData`);
        axiosResponseHandler(response);
        const res = response.data;

        if (res.status === 'success') {
            console.log(res);
            const { components = {} } = res.customUiData;
            const { header = {},bottomNavBar={} } = components;
            headerColorInput.value = header?.color || '#f9f4f4';
            headerBackgroundColorInput.value = header?.backgroundColor || '#4154f1';
            bottomNavbarBackgroundColorInput.value = bottomNavBar?.backgroundColor || '#4154f1';
        }
    } catch (error) {
        axiosErrorHandler(error);
        console.log(error);
    }
};
getCustomUiData();




const updateHeaderUi = async () => {

    const data = {
        color: headerColorInput.value,
        backgroundColor: headerBackgroundColorInput.value,


    };
    callTheApServerPost(`/customUi/updateHeaderUi`, { data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'data Updated',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });

};
window.updateHeaderUi = updateHeaderUi;


const updateBottomNavbar = async () => {

    const data = {

        backgroundColor: bottomNavbarBackgroundColorInput.value,


    };
    callTheApServerPost(`/customUi/updateBottomNavbar`, { data }).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;






        if (res.status === 'success') {
            console.log(res);


            Swal.fire({
                title: 'data Updated',
                icon: 'success',
                showConfirmButton: false,


                allowOutsideClick: false,


            });

            setTimeout(() => {
                location.reload();
            }, 3000);



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });

};
window.updateBottomNavbar = updateBottomNavbar;

